const theme = {
    primary: '#fff',
    componentBackground: '#fff',
    componentBackgroundSecondary: '#fff',
};

export default theme;